/**
 * @file router Mixin
 */
import axios from 'axios'
import store from './store'
import { Bridge, BridgeBasePath } from './constants'

const doc = global.document

/**
 * 设置title
 * @param {String} path # 页面路由path
 */
export function setTitle({ path }) {
  if (path === '/login' || path === '/' || path.indexOf('admin') > -1) doc.title = '桥梁防腐除湿监控系统'
  if (path.indexOf('jiajiang') > -1) doc.title = '南京夹江大桥除湿系统监控'
  if (path.indexOf('qingShui') > -1) doc.title = '清水河大桥除湿系统监控'
  if (path.indexOf('niZhou') > -1) doc.title = '南沙大桥坭洲水道桥除湿系统监控'
  if (path.indexOf('daSha') > -1) doc.title = '南沙大桥大沙水道桥除湿系统监控'
  if (path.indexOf('sutong') > -1) doc.title = '苏通大桥除湿系统监控'
  if (path.indexOf('nansi') > -1) doc.title = '南京四桥除湿系统监控'
}

/**
 * 验证登陆和权限
 * @param {Object} to
 * @param {Object} from
 * @param {Object} router
 * @param {Function} next
 */
export function verificationLoginPower(to, from, router, next) {
  const authAry = []
  const { path } = to
  console.log('path', path)
  if (path.indexOf('/login') === -1) {
    axios.get('/auth/LoginInfo').then(({ data = {} }) => {
      data.authorisedBridgeList.forEach(id => {
        if (Bridge[id]) authAry.push({ ...Bridge[id], id })
      })
      const isAdmin = data.userType === 'ADMIN' // 是否管理员
      store.dispatch('setBridgeList', authAry)
      store.dispatch('setIsAdmin', isAdmin)
      const $index = authAry.findIndex(val => path.indexOf(val.basePath) > -1)
      if (path === '/' && authAry.length === 0) {
        next()
        router.push('/login')
      } else if ((path === '/' && authAry.length > 1)) {
        next()
      } else if ($index > -1) {
        console.log('大桥权限验证通过')
        next()
      } else if (path.indexOf('/admin') > -1 && isAdmin) {
        console.log('管理员权限验证通过')
        next()
      } else if (path === '/admin/dataHistory' || path === '/admin/userControl' || path === '/admin/userLoginHistory' || path === '/admin/socketCommStatusControl'
        || path === '/admin/socketCommStatusDetail' || path === '/admin/historyAccessControl' || path === '/admin/socketCommHistoryDetail') {
        next()
      } else if (path !== '/' && $index === -1 && authAry.length > 0) {
        console.log(222)
        next()
        router.push('/')
      } else if (path === '/' && $index === -1 && authAry.length > 0) {
        next()
      } else {
        console.log(333)
        next()
        router.push('/login')
      }
    }).then(() => next()).catch(() => {
      let $url = '/login'
      BridgeBasePath.forEach(val => {
        if (path.indexOf(val) > -1) $url = `/${val}/login`
      })
      next()
      router.push($url)
    })
  } else {
    next()
  }
}
